import React from 'react';
import { Link } from 'react-router-dom';
import BankAccountTable from './components/BankAccountTable';

const BankAccount = () => {
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Daftar Rekening Bank</h1>
          <div className="d-flex">
            <Link to="/bank-account/create" className="button -md h-50 bg-blue-1 text-white">
              <i className="fa fa-plus mr-10 text-18" />
              Tambah Rekening Bank
            </Link>
          </div>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20" style={{ minHeight: 540 }}>
          <BankAccountTable />
        </div>
      </div>
    </div>
  );
};

export default BankAccount;
